import { Box, Body } from './'

export const Bullets = ({ items, dark }) => (
  <Box className="text-list">
    {items.map((item, i) =>
      <Box key={i} gap={10}>
        <Bullet dark={dark}/>
        <Body color={dark ? "black" : "white"} size={16} lineHeight="150%">{item}</Body>
      </Box>
    )}
  </Box>
)

const Bullet = ({ dark }) => (
  <Box minWidth={24} minHeight={25}>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.573242" width="24" height="24" rx="12" fill={dark ? "black" : "white"}/>
      <path d="M9.99997 16.1593L6.70697 12.8663L5.29297 14.2803L9.99997 18.9873L19.707 9.28027L18.293 7.86627L9.99997 16.1593Z" fill={dark ? "white" : "black"}/>
    </svg>
  </Box>
)